import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Shield, CreditCard, BarChart3, Zap } from 'lucide-react';
export function ValueProposition() {
  const benefits = [{
    icon: <BarChart3 className="w-7 h-7 text-brand-gold" data-id="element-291" />,
    title: 'Entiende cómo funciona realmente el crédito en USA',
    desc: 'Domina los 5 factores que determinan tu puntaje y úsalos a tu favor.'
  }, {
    icon: <TrendingUp className="w-7 h-7 text-brand-gold" data-id="element-292" />,
    title: 'Aprende a subir tu score de forma estratégica',
    desc: 'Acciones concretas que generan resultados reales, no trucos temporales.'
  }, {
    icon: <Shield className="w-7 h-7 text-brand-gold" data-id="element-293" />,
    title: 'Evita errores que dañan tu historial',
    desc: 'Identifica y elimina los hábitos que están frenando tu progreso financiero.'
  }, {
    icon: <CreditCard className="w-7 h-7 text-brand-gold" data-id="element-294" />,
    title: 'Construye crédito desde cero correctamente',
    desc: 'La ruta exacta para quienes empiezan sin historial en Estados Unidos.'
  }, {
    icon: <Zap className="w-7 h-7 text-brand-gold" data-id="element-295" />,
    title: 'Mantén un sistema estable a largo plazo',
    desc: 'Automatiza tu crédito para que crezca sin estrés ni complicaciones.'
  }];
  return <section className="py-24 bg-white" data-id="element-296">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-297">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-298">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-brand-black mb-6 leading-tight" data-id="element-299">
            NO ES SOLO INFORMACIÓN…
            <br data-id="element-300" />
            <span className="text-brand-green" data-id="element-301">
              ES UN SISTEMA COMPLETO PARA TRANSFORMAR TU CRÉDITO
            </span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-302">
            Aprende a entender, mejorar y controlar tu crédito en Estados Unidos
            con estrategias claras y aplicables desde el primer día.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-303">
          {benefits.map((item, index) => <motion.div key={index} className={`bg-brand-gray rounded-2xl p-8 border border-gray-100 ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} data-id="element-304">
              <div className="w-14 h-14 bg-brand-green rounded-xl flex items-center justify-center mb-5 shadow-md" data-id="element-305">
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-brand-black mb-2" data-id="element-306">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-307">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}